module.exports = __webpack_public_path__ + "img/order_icon_coupons.8711686a.png";